import React, { useCallback, useMemo } from "react";
import "../sass/layout/_banner.scss";
import "../sass/base/_base.scss";
import { useNavigate } from "react-router-dom";
import useWindowDimensions from "../hooks/useWindowDimensions.js";


export const Banner = ({
  style,
  id,
  width,
  heading,
  backgroundColor,
  textTransform,
  fontSize,
  renderFormButton,
  addLetterSpacing,
  headingContinued,
  headingStyle
}) => {
  const navigate = useNavigate();
  const { width: windowWidth } = useWindowDimensions();

  const navToBook = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    navigate("/contact");
  }, [navigate]);

  const renderHeading = useMemo(() => {
    if (renderFormButton) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <h1
            style={{
              ...headingStyle,
              width: width,
              letterSpacing: addLetterSpacing && "0.3rem",
              fontSize: fontSize,
              textTransform: textTransform,
              alignSelf: "center",
            }}
          >
            {heading}
            {"\n"}
            {headingContinued && headingContinued}
          </h1>

          {window.location.href.indexOf("book") === -1 && (
            <button
              className="button-pinkish"
              onClick={navToBook}
              style={{
                width: width > 600 ? "15rem" : "12rem",
                marginTop: windowWidth > 600 ? "0.3rem" : "0.3rem",
                textAlign: "center",
                alignSelf: "center",
                transition: "all ease 0.3s",
                boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.2)"
              }}
            >
              Enquire Now
            </button>
          )}
        </div>
      );
    }

    return (
      <h1
        style={{
          ...headingStyle,
          letterSpacing: addLetterSpacing && "0.3rem",
          width: width,
          fontSize: fontSize,
          textTransform: textTransform,
          alignSelf: "center",
        }}
      >
        {heading}
        {"\n"}
        {headingContinued && headingContinued}
      </h1>
    );
  }, [addLetterSpacing, fontSize, heading, headingContinued, headingStyle, navToBook, renderFormButton, textTransform, width, windowWidth]);

  return (
    <div
      id={id ? id : ""}
      style={{
        ...style,
        height: (renderFormButton && width > 600) ? "inherit" : style.height ? style.height : "18vh",
        backgroundColor: backgroundColor,
        alignSelf: "center",
        textAlign: "center",
      }}
      className="banner-container"
    >
      {renderHeading}
    </div>
  );
};
